function Container({ as: Tag = 'div', className = '', children, ...rest }) {
  return (
    <Tag className={`mx-auto w-full max-w-page px-5 sm:px-8 ${className}`} {...rest}>
      {children}
    </Tag>
  );
}

export default Container;
